import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', {
  state: () => ({
    isTgApp: false,
    lang: 'ru',
  }),
  actions: {
    setTgApp(value) {
      this.isTgApp = Boolean(value)
    },
    setLang(lang) {
      this.lang = lang
    },
  },
})
